import React, { useCallback, useState, useEffect } from "react";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import "./style.css";
import { addNotification as notify } from "reapop";
import { api_v2 } from "../../NewIndex.api";
import { validateField } from "../../../pages/functions";
import Select from "../../../forms/Select";
import connect from "react-redux/es/connect/connect";

const CopyModal = ({ isModalOpen, setTreeDraft, setCopyEnabled, props }) => {
  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };
  const copyFields = {
    country: {
      name: "Country",
      value: "",
      rules: { title: "Country", required: true },
    },
    userType: {
      name: "User Type",
      value: "",
      rules: { title: "User Type", required: true },
    },
    language: {
      name: "Language",
      value: "",
      rules: { title: "Language", required: true },
    },
  };
  const userLabels = {
    ABBVIE_EMPLOYEE: "Employee",
    HCP:"HCP",
    Patient:"Patient"
  }
  const [fields, setFields] = useState(copyFields);

  const [userTypeOptions, setUserTypeOptions] = useState([]);
  const [languageLabels, setLanguageLabels] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);

  const [apiData, setApiData] = useState([]);

  useEffect(() => {
    const languageOptions = [];
    api_v2.fetchTETLanguage((JsonKeys) => {
      JsonKeys.forEach((languageList) => {
        languageOptions.push({
          value: languageList.code,
          label: languageList.language,
        });
      });
      const languageLabels = languageOptions.reduce((acc, item) => {
        acc[item.value] = item.label;
        return acc;
      }, {});
      setLanguageLabels(languageLabels);
    });
  }, []);

  useEffect(() => {
    api_v2.copyOptions((res) => {
      setApiData(res);
      const countries = [...new Set(res.map((item) => item.country))];
      const uniqueCountries = countries.map((country) => ({
        label: country,
        value: country,
      }));
      setCountryOptions(uniqueCountries);
    });
  }, []);

  //run this useEffect whenever country value changes
  useEffect(() => {
    if (fields.country.value) {
      const userTypesSet = new Set(
        apiData
          .filter((i) => i.country === fields.country.value)
          .map((i) => i.userType)
      );
      setUserTypeOptions(
        [...userTypesSet].map((type) => ({ label: userLabels[type], value: type }))
      );
    } else {
      setUserTypeOptions([]);
    }
  }, [fields.country.value, apiData]);

  //run this useEffect whenever fileds.country value and fields.userType.value changes
  useEffect(() => {
    if (fields.country.value && fields.userType.value) {
      const langSet = new Set(
        apiData
          .filter(
            (i) =>
              i.country === fields.country.value &&
              i.userType === fields.userType.value
          )
          .map((i) => i.language)
      );
      setLanguageOptions(
        [...langSet].map((lang) => ({
          label: languageLabels[lang] || lang,
          value: lang,
        }))
      );
    } else {
      setLanguageOptions([]);
    }
  }, [fields.country.value, fields.userType.value, apiData, languageLabels]);

  const resetState = () => {
    let fieldsValue = fields;
    fieldsValue.country.value = "";
    fieldsValue.userType.value = "";
    fieldsValue.language.value = "";
    setFields({ ...fieldsValue });
  };

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const emojiRegex =
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF\uD83D\uDE00-\uDE4F])/g;
      const scriptRegex =
        /<script>|<iframe>|<embed>|<object>|<link>|<img>|<svg>|<textarea>|<meta>|<form>|\bscript\b|\bonerror\b|\bonload\b|\bonclick\b|\bonmouseover\b|\bsrc\b|\bhref\b|%3cscript%3e|%3ciframe%3e|%3cembed%3e|%3cobject%3e|%3clink%3e|%3cimg%3e|%3csvg%3e|%3ctextarea%3e|%3cmeta%3e|%3cform%3e/g;

      if (emojiRegex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (scriptRegex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );

  const toggleYes = useCallback(() => {
    const payload = {
      country: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
    };
    if (
      fields.country.value &&
      fields.userType.value &&
      fields.language.value
    ) {
      api_v2.copyData(payload, (res) => {
        setTreeDraft(res.hierarchical);
        showNotification("Success", "Copied Successfully", "success");
        setCopyEnabled(false);
      });
    }
  }, [fields]);

  return (
    <Modal
      className="adminConfirmation-popup-modal"
      isOpen={isModalOpen}
      backdrop
      keyboard={false}
      wrapClassName="modal-primary"
      size="lg"
    >
      <ModalBody>
        <div className="adminConfirmationModal-modal-body-content">
          <div style={{ marginBottom: "15px", fontSize: "larger" }}>
            Copy from options
          </div>
          <div className="row copyFromModel-select">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={countryOptions}
                field={fields.country}
                validate={(e) => validate(e, fields.country)}
                onChange={() => {
                  let fieldsValue = fields;
                  fieldsValue.userType.value = "";
                  fieldsValue.language.value = "";
                  setFields({ ...fieldsValue });
                }}
              />
            </div>
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={userTypeOptions}
                field={fields.userType}
                validate={(e) => validate(e, fields.userType)}
                onChange={() => {
                  let fieldsValue = fields;
                  fieldsValue.language.value = "";
                  setFields({ ...fieldsValue });
                }}
              />
            </div>
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={languageOptions}
                field={fields.language}
                validate={(e) => validate(e, fields.language)}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
        <div className="adminConfirmationModal-popup-button">
          <button
            type="button"
            onClick={toggleYes}
            className="btn btn-primary adminConfirmationModal-button btn-rounded"
          >
            Retrieve
          </button>
          <button
            type="button"
            onClick={() => setCopyEnabled(false)}
            className="btn btn-primary adminConfirmationModal-button btn-rounded"
          >
            Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps, { notify })(CopyModal);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AMI/CopyModal.js